import React from 'react';
import styled from 'styled-components';

import Icon from 'relements/build/esm/ui/icon';
import Box from 'relements/build/esm/ui/box';
import Text from 'relements/build/esm/ui/text';

export const Wrapper = styled(Box)`
  border: 1px solid ${(props) => props.theme.colors.grey.haptik};
  align-items: center;
  border-radius: ${(props) => props.theme.radii.sm}px;
  flex-direction: column;
  padding: 80px 0px;
`;

export const SuccessWrapper = styled(Wrapper)`
  padding: 0px;
`;

export const ToggleWrapper = styled(Box)`
  border-top: 1px solid ${(props) => props.theme.colors.grey.haptik};
  width: 96%;
  align-items: center;
  padding: 24px 20px;
  & > div {
    width: 100%;
  }
`;

const IconWrapper = styled(Icon)`
  width: 32px;
  height: 32px;
`;

const MessageWrapper = styled(Box)((props) => ({
  borderWidth: props.theme.borderWidths.xs,
  marginBottom: 20,
  padding: 24,
  alignItems: 'center',
  borderRadius: props.theme.radii.sm,
  width: '50%',
}));

export const Warning = ({ message }) => (
  <MessageWrapper backgroundColor="yellow.pastel" borderColor="yellow.soft">
    <IconWrapper src="outlier" />
    <Box padding={0} pl={16} width="90%">
      <Text variant="body.lg">{message}</Text>
    </Box>
  </MessageWrapper>
);

export const Blocker = ({ message }) => (
  <MessageWrapper backgroundColor="red.pastel" borderColor="red.haptik">
    <IconWrapper src="botbreak" />
    <Box padding={0} pl={16} width="90%">
      <Text variant="body.lg" color="red.haptik">
        {message}
      </Text>
    </Box>
  </MessageWrapper>
);

export const Success = ({ message }) => (
  <MessageWrapper backgroundColor="green.pastel" borderColor="green.haptik">
    <IconWrapper src="tick-green" />
    <Box padding={0} pl={16} width="90%">
      <Text variant="body.lg">{message} </Text>
    </Box>
  </MessageWrapper>
);
